'use no memo'

import { useMemo } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useSpaceViewPageSetup } from '../hooks/useSpaceViewPageSetup'
import { ViewsListTable } from '@/routes/features/views/ViewsListTable'
import { Loading } from '@/components/app/indicators/Loading'
import { usePageLayout } from '@/hooks/usePageLayout'

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/views/',
)({
  component: SpaceViewsIndexPage,
})

function SpaceViewsIndexPage() {
  const { workspaceSlug, spaceKey } = Route.useParams()
  const { space, spaceLoading } = useSpaceViewPageSetup(
    workspaceSlug,
    spaceKey,
    () => null,
  )

  const breadcrumbActions = useMemo(() => null, [])
  usePageLayout({ breadcrumbActions }, [space?.id])

  if (spaceLoading) {
    return (
      <div className="flex min-h-full flex-1 items-center justify-center">
        <Loading />
      </div>
    )
  }

  if (!space) return null

  return (
    <ViewsListTable
      scope="space"
      scopeEntityId={space.id}
      scopeKey={spaceKey}
      workspaceSlug={workspaceSlug}
    />
  )
}
